import { hot } from 'react-hot-loader';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  matchPath,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { createTheme } from 'mineral-ui/themes';
import {
  AppFrame,
  PrivateRoute,
} from './components';
// Top Level Route Components
import Home from './pages/Home';
import FormsRouter from './pages/FormsRouter';
import LoginRedirect from './pages/login/LoginRedirect';
import Login from './pages/Login';
import PlansRouter from './pages/PlansRouter';
import SettingsClientRouter from './pages/SettingsClientRouter';
import SettingsCarrierRouter from './pages/SettingsCarrierRouter';
import FeatureRouter from './pages/FeatureRouter';
import { bootApp } from './modules/bootComplete';
import { updateTheme as updateThemeAction } from './modules/theme';
import { updateLanguage as updateLanguageAction } from './modules/supportedLanguage';
import { AllPostMessages } from './listeners';
import { getFeatures } from './modules/selectors';
import ContentRouter from './pages/ContentRouter';
import StaticRouter from './pages/StaticFilesRouter';
import { Languages } from './utils/constants';


const propTypes = {
  features: PropTypes.shape({
    customContent: PropTypes.bool,
    forms: PropTypes.bool,
    plans: PropTypes.bool,
    staticFiles: PropTypes.bool,
  }).isRequired,
  bootAppDispatch: PropTypes.func.isRequired,
  updateTheme: PropTypes.func.isRequired,
  updateLanguage: PropTypes.func.isRequired,
};

class App extends Component {
  componentDidMount() {
    const {
      bootAppDispatch,
      updateTheme,
      updateLanguage,
    } = this.props;

    // Set theme to gray until we have fetched the theme
    const grayTheme = createTheme({
      colors: {
        theme: 'gray',
      },
    });
    updateTheme(grayTheme);

    // Default language to english.
    updateLanguage(Languages.en_US);

    // If the initial load has the carrier id in the url then use it
    const match = matchPath(window.location.pathname, {
      path: '/carriers/:carrierId',
    });
    const carrierId = match && match.params && match.params.carrierId;

    bootAppDispatch(carrierId);
  }

  render() {
    const { features } = this.props;

    let frameless = false;
    if (window.location.search.indexOf('frameless') !== -1) {
      frameless = true;
    }
    return (
      <AppFrame>
        {frameless && <AllPostMessages />}
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/carriers/:carrierId" component={Home} />
          <PrivateRoute path="/carriers/:carrierId/features" component={FeatureRouter} />
          {features.forms && <Route path="/carriers/:carrierId/forms" component={FormsRouter} />}
          <Route path="/login" component={Login} />
          <Route path="/loginredirect" component={LoginRedirect} />
          {features.customContent && <Route path="/contents" component={ContentRouter} />}
          {features.customContent && <Route path="/carriers/:carrierId/contents" component={ContentRouter} />}
          {features.staticFiles && <Route path="/carriers/:carrierId/staticFiles" component={StaticRouter} />}
          {features.plans && <Route path="/carriers/:carrierId/plans" component={PlansRouter} />}
          <PrivateRoute path="/settings" component={SettingsClientRouter} />
          <PrivateRoute path="/carriers/:carrierId/settings" component={SettingsCarrierRouter} />
        </Switch>
      </AppFrame>
    );
  }
}

function mapStateToProps(state) {
  return {
    features: getFeatures(state),
  };
}
const mapDispatchToProps = dispatch => ({
  bootAppDispatch: carrierId => dispatch(bootApp(carrierId)),
  updateTheme: theme => dispatch(updateThemeAction(theme)),
  updateLanguage: languageId => dispatch(updateLanguageAction(languageId)),
});

App.propTypes = propTypes;
export default hot(module)(withRouter(connect(mapStateToProps, mapDispatchToProps)(App)));
